import api from '../../utils/api';

export const removeCategory = (id: number) =>
  api.delete({
    url: `/category/${id}`,
  });
